/**
 * 背景のグラデーション。auth0-customization-assets のログインテンプレート
 * （html/auth0-universal-login/body.html の .spcustom-gradation）と同じ配色にする。
 * ページはスクロールするので、テンプレートと違って画面に固定する。
 * テンプレートの拡大縮小とマウス追従は付けない。すりガラスのカードが重なるこのページでは、
 * Safari が背景の動きに合わせて毎フレームぼかしを描き直し、操作の反映が数秒遅れるため
 */
export function Background() {
  return (
    <div className="gradation" aria-hidden="true">
      <div className="gradation__block gradation__block--1" />
      <div className="gradation__block gradation__block--2" />
      <div className="gradation__block gradation__block--3" />
      <div className="gradation__block gradation__block--4" />
    </div>
  );
}
